import React from 'react';
import { MultiSelect } from 'react-multi-select-component';
import SelectWithFilter from '../InputComponents/BaseInputs/Selectors/SelectWithFilter';

export default class ReportParamInputField extends React.Component {
  static defaultProps = {
    parameter: null,
    index: 0,
    value: '',
    onChange: (name, value) => {
      alert(`Parameter ${name} changed to ${value}`);
    },
    disabled: false,
    hidden: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  renderTextInputField() {
    return (
      <input
        type='text'
        value={this.props.value}
        onChange={(e) => this.props.onChange(this.props.parameter.name, e.target.value)}
        disabled={this.props.disabled}
      />
    );
  }

  renderListInputField() {
    const validValues = [{ label: 'Choose one...', value: -100 }].concat(
      this.props.parameter.validValues && this.props.parameter.validValues.length > 0
        ? this.props.parameter.validValues.map((item) => {
            return { label: item.label, value: item.value ? item.value : '' };
          })
        : []
    );
    return (
      <div style={{ display: 'inline-block', minWidth: '240px' }}>
        <div style={{ maxWidth: '600px' }}>
          <SelectWithFilter
            value={Array.isArray(this.props.value) ? this.props.value[0] : this.props.value}
            onChange={(e) => {
              this.props.onChange(this.props.parameter.name, e.value);
            }}
            className={'w-100 form-control form-control-sm'}
            showFilterAt={100000}
            selectValues={validValues}
            valueCanBeNull={true}
          />
        </div>
      </div>
    );
  }

  renderListInputMultiSelectField() {
    let validValues = [];

    validValues = validValues.concat(
      this.props.parameter.validValues && this.props.parameter.validValues.length > 0
        ? this.props.parameter.validValues
        : []
    );

    const values = Array.isArray(this.props.value) ? this.props.value : [];
    return (
      <div style={{ display: 'inline-block', minWidth: '240px' }}>
        <MultiSelect
          value={values}
          onChange={(selected) => this.props.onChange(this.props.parameter.name, selected)}
          disabled={this.props.disabled}
          options={validValues}
          className='multipleselect'
        />
      </div>
    );
  }

  getSelectedAsString(select) {
    if (select && select.options) {
      const result = [];
      for (var i = 0, l = select.options.length; i < l; i++) {
        let opt = select.options[i];
        if (opt.selected /*|| select.value === 'all') && opt.value !== '' && opt.value !== 'all'*/) {
          result.push(opt.value);
        }
      }
      return result;
    }
    return '';
  }

  renderDateInputField() {
    return (
      <input
        type='date'
        value={this.props.value}
        onChange={(e) => this.props.onChange(this.props.parameter.name, e.target.value)}
        disabled={this.props.disabled}
      />
    );
  }

  renderInputField() {
    if (this.props.parameter.validValues && this.props.parameter.validValues.length > 0) {
      if (this.props.parameter.multiValueSpecified && this.props.parameter.multiValue) {
        return this.renderListInputMultiSelectField();
      }
      return this.renderListInputField();
    }
    if (this.props.parameter.type === 1) {
      return this.renderDateInputField();
    }
    return this.renderTextInputField();
  }

  render() {
    if (this.props.hidden) {
      return null;
    }
    return (
      <div
        className='rf-field'
        key={`param${this.props.index}`}
      >
        <label>{this.props.parameter.prompt}</label>
        {this.renderInputField()}
      </div>
    );
  }
}
